import {
  GET_PLANNINGS_REQUEST,
  GET_PLANNINGS_SUCCESS,
  GET_PLANNINGS_ERROR,
  GET_PLANNINGS_DONE,
  ADD_PLANNING_REQUEST,
  ADD_PLANNING_SUCCESS,
  ADD_PLANNING_ERROR,
  UPDATE_PLANNING_REQUEST,
  UPDATE_PLANNING_SUCCESS,
  UPDATE_PLANNING_ERROR,
  DELETE_PLANNING_REQUEST,
  DELETE_PLANNING_SUCCESS,
  DELETE_PLANNING_ERROR,
} from "./actions";
import { DELETE_PLAYLIST_SUCCESS } from "../playlists/delete/actions";

const initialState = {
  requesting: false,
  successful: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLANNINGS_REQUEST:
      return {
        requesting: true,
        successful: false,
        plannings: undefined,
        error: undefined,
      };

    case GET_PLANNINGS_SUCCESS:
      return {
        requesting: false,
        successful: true,
        plannings: action.plannings,
        error: undefined,
      };

    case GET_PLANNINGS_ERROR:
      return {
        requesting: false,
        successful: false,
        plannings: undefined,
        error: action.error,
      };

    case GET_PLANNINGS_DONE:
      return {
        ...initialState,
        successful: state.successful,
        plannings: state.plannings,
      };

    case ADD_PLANNING_REQUEST:
      return {
        ...state,
        plannings: [
          ...state.plannings.filter(
            ({ tempId }) => tempId !== action.planning.tempId
          ),
          { ...action.planning, requesting: true, syncFailed: false },
        ],
      };

    case ADD_PLANNING_SUCCESS:
      return {
        ...state,
        plannings: [
          ...state.plannings.filter(
            ({ tempId, hourStart, hourEnd, dayOfWeek, playlistId }) => {
              return !(
                tempId == action.tempId ||
                (((hourStart >= action.planning.hourStart &&
                  hourStart <= action.planning.hourEnd) ||
                  (hourEnd >= action.planning.hourStart &&
                    hourEnd <= action.planning.hourEnd)) &&
                  dayOfWeek === action.planning.dayOfWeek &&
                  playlistId === action.planning.playlistId)
              );
            }
          ),
          action.planning,
        ],
      };

    case ADD_PLANNING_ERROR:
      return {
        ...state,
        plannings: [
          ...state.plannings.filter(
            ({ tempId }) => tempId !== action.planning.tempId
          ),
          { ...action.planning, requesting: false, syncFailed: true },
        ],
      };

    case UPDATE_PLANNING_REQUEST:
      return {
        ...state,
        plannings: [
          ...state.plannings.filter(({ id }) => id !== action.planning.id),
          { ...action.planning, requesting: true, syncFailed: false },
        ],
      };

    case UPDATE_PLANNING_SUCCESS:
      return {
        ...state,
        plannings: [
          ...state.plannings.filter(
            ({ id, hourStart, hourEnd, dayOfWeek, playlistId }) => {
              return !(
                id == action.planning.id ||
                (((hourStart >= action.planning.hourStart &&
                  hourStart <= action.planning.hourEnd) ||
                  (hourEnd >= action.planning.hourStart &&
                    hourEnd <= action.planning.hourEnd)) &&
                  dayOfWeek === action.planning.dayOfWeek &&
                  playlistId === action.planning.playlistId)
              );
            }
          ),
          { ...action.planning, requesting: false, syncFailed: false },
        ],
      };

    case UPDATE_PLANNING_ERROR:
      return {
        ...state,
        plannings: [
          ...state.plannings.filter(({ id }) => id !== action.planning.id),
          { ...action.planning, requesting: false, syncFailed: true },
        ],
      };

    case DELETE_PLANNING_REQUEST:
      return {
        ...state,
        plannings: [
          // eslint-disable-next-line max-len
          ...state.plannings.filter(
            ({ id, tempId }) =>
              id !== action.planning.id || tempId !== action.planning.tempId
          ),
          { ...action.planning, requesting: true },
        ],
      };

    case DELETE_PLANNING_SUCCESS:
      return {
        ...state,
        plannings: [
          // eslint-disable-next-line max-len
          ...state.plannings.filter(
            ({ id, tempId }) =>
              id !== action.planning.id || tempId !== action.planning.tempId
          ),
        ],
      };

    case DELETE_PLANNING_ERROR:
      return {
        ...state,
        plannings: [
          // eslint-disable-next-line max-len
          ...state.plannings.filter(
            ({ id, tempId }) =>
              id !== action.planning.id || tempId !== action.planning.tempId
          ),
          { ...action.planning, requesting: false },
        ],
      };

    case DELETE_PLAYLIST_SUCCESS:
      return {
        ...state,
        plannings: [
          ...state.plannings.filter(
            ({ playlistId }) => playlistId !== action.id
          ),
        ],
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/plannings/reducer.js